import Content from "./components/content";

const settings = window.wc.wcSettings.getSetting("payshop_reference_data", {});
const label = window.wp.htmlEntities.decodeEntities(settings.title);
const description = window.wp.htmlEntities.decodeEntities(settings.description);
const icon = settings.icon;

const Block_Gateway = {
    name: "payshop_reference",
    label: <div style={{display: "flex", alignItems: "center"}}>
            <span>{label}</span>
            <img src={icon} style={{marginLeft: "10px", height: "18px", maxHeight: "18px"}} />
        </div>,
    content: <Content>
            {description}
        </Content>,
    edit: <div>{label}</div>,
    canMakePayment: () => true,
    ariaLabel: label,
    supports: {
        features: settings.supports,
    },
};

window.wc.wcBlocksRegistry.registerPaymentMethod(Block_Gateway);